<form [formGroup]="form" class="style-form">
    <!-- <div class="style-input-default" data-text="Accion autorizada *" [ngClass]="{error: verificateInput('nombre_empresa')}"> -->
      <!-- <input type="text" placeholder="Accion autorizada" formControlName="accion_autorizada"> -->
     
     <div style="display: flex;">
         <p class="inputRadio">¿Acción autorizada?</p>
        <mat-radio-group style="margin-left: 60px;" formControlName="accion_autorizada" aria-label="Select an option">
            <mat-radio-button value="Si">Si</mat-radio-button>
            <mat-radio-button  style="margin-left:10px" value="No">No</mat-radio-button>
          </mat-radio-group>
     </div>
     <div style="display: flex;padding: 16px 15px;" class="check">
         <p class="inputRadio">Solicita copia del comprobante de autorización</p>
        <section class="section">
            <mat-checkbox  formControlName="copia" class="example-margin" ></mat-checkbox>
        </section>
     </div>
    
    <!-- </div> -->
    <!-- <div class="style-input-default" data-text="Observaciones *" [ngClass]="{error: verificateInput('rif')}">
      <input type="text" placeholder="Escriba sus observacioes" formControlName="observaciones">
    </div> -->
</form>
